import React, { useState } from 'react';
import './Footer.css';
import { FaDiscord, FaInstagram, FaLinkedin, FaTwitter, FaEnvelope, FaHeart } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  const socialLinks = [
    { name: 'Discord', icon: <FaDiscord />, url: 'https://discord.gg/qYY4CphH' },
    { name: 'Instagram', icon: <FaInstagram />, url: '#' },
    { name: 'LinkedIn', icon: <FaLinkedin />, url: '#' },
    { name: 'Twitter', icon: <FaTwitter />, url: '#' }
  ];

  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <h3>ResoREP</h3>
            <p>Your ultimate resource repository for academic excellence.</p>
          </div>
          
          <div className="footer-links">
            <div className="footer-links-column">
              <h4>Quick Links</h4>
              <Link to="/">Home</Link>
              <Link to="/about">About</Link>
              <Link to="/subject?activeTab=papers">Past Papers</Link>
              <Link to="/subject?activeTab=resources">Resources</Link>
            </div>
            
            <div className="footer-links-column">
              <h4>Support</h4>
              <Link to="#">Contact Us</Link>
              <Link to="#">FAQ</Link>
              <Link to="#">Privacy Policy</Link>
              <Link to="#">Terms of Service</Link>
            </div>
          </div>
          
          {/* <div className="footer-newsletter">
            <h4>Stay Updated</h4>
            <p>Subscribe to our newsletter for the latest resources and updates.</p>
            <div className="newsletter-form">
              <input type="email" placeholder="Your email address" />
              <button><FaEnvelope /></button>
            </div>
          </div> */}
        </div>
        
        <div className="footer-divider"></div>
        
        <div className="footer-bottom">
          <div className="footer-social">
            {socialLinks.map((link, index) => (
              <a
                href={link.url}
                key={index}
                className="social-icon"
                aria-label={link.name}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                style={{
                  opacity: hoveredIndex === null || hoveredIndex === index ? 1 : 0.6
                }}
              >
                {link.icon}
              </a>
            ))}
          </div>
          
          <div className="footer-copyright">
            <p>© {new Date().getFullYear()} ResoREP. Made with <FaHeart className="heart-icon" /> for students, by students</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 